import { render, staticRenderFns } from "./MenuPart.vue?vue&type=template&id=0104ada0"
import script from "./MenuPart.vue?vue&type=script&lang=js"
export * from "./MenuPart.vue?vue&type=script&lang=js"
import style0 from "./MenuPart.vue?vue&type=style&index=0&id=0104ada0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports